import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import MoreInfo from "../../../../lib/MoreInfo";
import Subscription from "../../../../lib/Subscription";
import bikeTypeSupportsFitting from "../../FittingSupport";
import Progress from "../../Progress";

class BeforeSizes extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			mtbType: this.props.mtbType,
			measure: this.props.measure,
			value: this.props.beforeSizes,
			hasSubsription: false
		};

		if ( ! bikeTypeSupportsFitting(this.props.mtbType)) {
			this.skip();
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			mtbType: nextProps.mtbType,
			measure: nextProps.measure,
			value: nextProps.beforeSizes
		});
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		console.log(this.props.chosenIntegrationOption)
		Subscription.checkSubscription("bikefit").then((hasSubsription)=>{
			this.setState({hasSubsription:hasSubsription})
		})
	}

	render() {
		return (
			<div className="container main">
				<div className="info-overlay"></div>
				<div className="more-info">
					<i className="closeInfo fas fa-times"></i>
					<div className="more-info-container"></div>
				</div>
				<Progress goTo={this.props.goTo} step={2} traject={this.props.traject} />
				<form className="row beforeSizes" onSubmit={this.handleSubmit}>

					<div className="col-12 text-center title">
						<h2>{this.props.t('Hoe moeten we jouw optimale zitpositie bepalen?')}</h2>
						<span className="sub-title">{this.props.t('BeforeSizes-Het is')}. <span className="moreInfo link" onClick={() => { MoreInfo.show('info', 'posture') }}>{this.props.t('BeforeSizes-Hier vind je')}.</span>
							{' '}{this.props.t('BeforeSizes-Heb je nu')}.</span>
					</div>

					<div className="col-12 option">

						<div className="row">
							<div className="col-sm-7" style={{ background: "url(/img/persoon_maten_groot.png)" }}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{this.props.t('Adviseer mij')}</h3>
									<span>{this.props.t('BeforeSizes-Graag wil ik')}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div className="radio-container">
									<input type="radio" name="beforeSizes" checked={this.state.value === 'body' ? 'checked' : ''} value="body" onChange={this.handleChange} />
								</div>
							</div>
						</div>
					</div>
					{this.props.traject === 'mtb' &&
						<div className="col-12 option">
							<div className="row">
								<div className="col-sm-7" style={{ background: "url(/img/mtb_maten.png)" }}>
								</div>
								<div className="col-sm-4 vcenter">
									<div>
										<h3>{this.props.t('Identiek aan huidige MTB')}</h3>
										<span>{this.props.t('measurements, mtb to mtb')}</span>
									</div>
								</div>
								<div className="col-sm-1 vcenter">
									<div className="radio-container">
										<input type="radio" name="beforeSizes" checked={this.state.value === 'mtb' ? 'checked' : ''} value="mtb" onChange={this.handleChange} />
									</div>
								</div>
							</div>
						</div>
					}
					{this.props.traject === 'race' &&
					<div className="col-12 option">
						<div className="row">
							<div className="col-sm-7" style={{background: "url(/img/race_maten.png)"}}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{this.props.t('measurements title, race to ' + this.props.traject)}</h3>
									<span>{this.props.t('measurements, race to ' + this.props.traject)}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div className="radio-container">
									<input type="radio" name="beforeSizes"
										   checked={this.state.value === 'race' ? 'checked' : ''} value="race"
										   onChange={this.handleChange}/>
								</div>
							</div>
						</div>
					</div>
					}
					<div className="col-12 option">

						<div className="row">
							<div className="col-sm-7" style={{ background: "url(/img/skip_option.png)"}}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{this.props.t('Geen maatadvies')}</h3>
									<span>{this.props.t('BeforeSizes-Ik ben nu niet')}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div className="radio-container">
									<input type="radio" name="beforeSizes" checked={this.state.value === 'skip' ? 'checked' : ''} value="skip" onChange={this.handleChange} />
								</div>
							</div>
						</div>
					</div>
					<div className="col-6 text-left">
						<button className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
					</div>
					<div className="col-6 text-right">
						<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t("Volgende")} />
					</div>
				</form>



			</div>
		);

	}

	handleChange = (event) => {
		this.setState({ value: event.target.value, measure: event.target.value});
	};

	handleSubmit = (event) => {
		event.preventDefault();
		this.props.handler(this.state.value).then(() => {
			switch (this.state.value) {
				case 'body':
					this.props.goTo('/advice/sizes/body', this.props.traject);
					break;
				case 'mtb':
					this.props.goTo('/advice/sizes/mtb', this.props.traject);
					break;
				case 'race':
					this.props.goTo('/advice/sizes/race', this.props.traject);
					break;
				case 'skip':
				default:
					this.skip();
					break;
			}
		});
	};

	goBack = (e) => {
		e.preventDefault();
		this.props.chosenIntegrationOption === "option3" && this.state.hasSubsription ?
		this.props.goTo('/advice/integration', this.props.traject)
		:
		this.props.goTo('/advice/gender', this.props.traject);
	};

	skip = () => {
		this.props.setNoFit();
		this.nextStep()
	};

	nextStep = () => {
		this.props.goTo('/advice/price', this.props.traject);
	};
}

export default withTranslation("beforeSizes")(BeforeSizes);
